import { render, staticRenderFns } from "./Embr.vue?vue&type=template&id=84c63560&scoped=true&"
import script from "./Embr.vue?vue&type=script&lang=js&"
export * from "./Embr.vue?vue&type=script&lang=js&"
import style0 from "./Embr.vue?vue&type=style&index=0&id=84c63560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c63560",
  null
  
)

export default component.exports